import {useStore} from "vuex";
import {computed} from "vue";

export function useTeam() {
	const store = useStore();
	const team = computed(function () {
		return store.state.team.data.team;
	});

	const activeMember = computed(function () {
		return store?.state?.team?.data?.activeMember;
	});

	const setActiveMember = (payload) => {
		store.commit('team/setActiveMember', payload);
	}

	return {
		team,
		setActiveMember,
		activeMember
	}
}